import { useSelector } from "react-redux";
import { useReactFlow } from "reactflow";
import TimelineItem from "cxfcomponents/Timeline/TimelineItem";
import SoftBox from "components/SoftBox";
import { getLocalTimeString } from "helpers/common";
import { highlightNode } from "layouts/Flow Designer/helpers/common";
import ItemDescription from "./ItemDescription";
import capitalizeFirstLetter from "helpers/capitalizeFirstLetter";

const getBadgeColor = (remarks) => {
  if (remarks === "Success") {
    return "success";
  } else if (remarks === "Failed") {
    return "error";
  }
  return "info";
};

const ReportItem = ({ item, isFirst, isLast, isLastReportData }) => {
  const { setCenter, getZoom, getNode, setNodes } = useReactFlow(); // ReactFlow hook to control the viewport
  const { currentFlowTab } = useSelector((store) => store?.designer?.tabs);
  const node = getNode(item.nodeId);
  let isExecutionEnded = false;
  const isActionEnd = item.action?.toLowerCase()?.includes("end");
  const isReportPanelActive =
    useSelector((store) => store.designer.tabs.activeFlexLayoutTab) === "executionReport";

  const title = item.isLabel
    ? "Label"
    : item.componentLabel || capitalizeFirstLetter(item.componentKey).split("_").join(" ") || "";

  const color = getBadgeColor(item.remarks);

  if (isLastReportData) {
    if (isFirst) {
      highlightNode("1", "Success");
    }

    if (isLast && !currentFlowTab.isExecuting && isReportPanelActive) {
      isExecutionEnded = true;
      highlightNode("2", "Success");
    }
  }

  const handleClick = () => {
    if (node) {
      const currentZoom = getZoom();

      setCenter(node.position.x + node.width / 2, node.position.y + node.height / 2, {
        zoom: currentZoom,
        duration: 500
      });
      setNodes((prev) => prev.map((n) => ({ ...n, selected: n.id === item.nodeId })));
    }
  };

  if (item.isLabel) {
    return <div style={{ height: 1 }} />;
  }

  return (
    <SoftBox onClick={handleClick} style={{ cursor: "pointer" }} sx={{ paddingRight: "1rem" }}>
      <TimelineItem
        nodeId={item.nodeId}
        color={color}
        icon={(isExecutionEnded && !currentFlowTab.isExecuting) || isFirst ? "flag" : "circle"}
        title={
          <span
            style={{
              color: "inherit",
              transition: "color 0.2s ease",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => (e.target.style.color = "#7B61FF")} // Change color on hover
            onMouseLeave={(e) => (e.target.style.color = "inherit")} // Revert color on leave
          >
            {title}
          </span>
        }
        dateTime={getLocalTimeString(item.startTime)}
        description={<ItemDescription item={item} />}
        badges={[
          { content: item.remarks, color: color },
          { content: item.componentKey, color: "info" }
        ]}
        undefinedPaths={item.undefinedPaths}
        lastItem={isLast}
        response={item.response}
        isActionEnd={isActionEnd}
        componentKey={item.componentKey}
      />
    </SoftBox>
  );
};

export default ReportItem;
